<template>
  <div class="news_box">
    <img class="news_icon" src="../../../assets/img/home/icon_news.png" alt="">
    <input class="news_input" type="text" placeholder="2019/02/21 結算延遲通知">
    <div class="news_more">看更多...</div>
  </div>
</template>

<script>
export default {
  name: 'HomeNews',
  props: {
  },
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .news_box {
    display: flex;
    padding: 12px 0px;
    font-size: 13px; 
  }
  .news_icon {
    padding: 6px 14px;
    width: 20px;
    height: 19px;
  }
  .news_input {
    flex: 1;
    height: 28px;
    line-height: 28px;
    background: #f2f2f2;
    padding-left: 12px;
  }
  .news_more {
    cursor:pointer;
    color: #2a1c2e;
    height: 26px;
    line-height: 26px;
    border-bottom: 1px solid #2a1c2e;
    margin: 0 23px;
  }


/*  */
@media screen and (max-width:768px){
   .news_box {
    display: flex;
    padding: 1.6vw 0px;
    font-size: 2.5vw; 
  }
  .news_icon {
    padding: .8vw 1.9vw;
    width: 2.7vw;
    height: 2.5vw;
  }
  .news_input {
    flex: 1;
    height: 4.3vw;
    line-height: 4.3vw;
    background: #f2f2f2;
    padding-left: 1.6vw;
  }
  .news_more {
    cursor:pointer;
    color: #2a1c2e;
    height: 4.3vw;
    line-height: 4.3vw;
    border-bottom: 1px solid #2a1c2e;
    margin: 0 2.1vw;
  }
}
</style>
